export const ProfileAddress = {
  REGISTER_ADDRESS: 1,
  EDIT_ADDRESS: 2,
};

export const ProfileRegister = {
  REGISTER_PROFILE: 1,
  EDIT_PROFILE: 2,
};